import _ from 'lodash';

/** `ERROR_CODES.ALREADY_EXISTS` aus `@pai/shared` — das Frontend hängt nicht an dem Paket (siehe offer-field.utils.ts). */
const ALREADY_EXISTS = 'ALREADY_EXISTS';

/**
 * Erkennt „der Kampagnenname ist im Mandanten schon vergeben“ in einer Fehlerantwort.
 *
 * Das Backend antwortet mit `409` und dem Code `ALREADY_EXISTS`, verpackt als
 * `{ success: false, error: { code, message } }`. Die Erkennung darf nicht an der obersten
 * Ebene nach `message` greifen — genau das tat sie, fand nichts, und der Nutzer bekam den
 * roten Sammeldialog („INTERNAL_ERROR … already exists“) statt des Hinweises am Namensfeld.
 * Die Meldung bleibt als Rückfallebene für ältere API-Stände, die den Code nicht setzen.
 */
export function isCampaignNameTakenError(error: unknown): boolean {
  if (_.isNil(error) || typeof error !== 'object') {
    return false;
  }

  const nested = (error as { error?: unknown }).error;
  const inner = !_.isNil(nested) && typeof nested === 'object' ? (nested as { code?: unknown; message?: unknown }) : (error as { code?: unknown; message?: unknown });

  if (inner.code === ALREADY_EXISTS) {
    return true;
  }

  return typeof inner.message === 'string' && /already exists/i.test(inner.message);
}
